import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import { fetchHygineTaskCategoryData } from "../../redux/hygiene-reducers/hygieneSlice";
import TaskCategoryForm from "../../components/hygiene-system/categories/TaskCategoryForm";
import HygieneCategoryListings from "../../components/hygiene-system/hygiene-new-categories/HygieneCategoryListings";
import MealsStructure from "../../components/diet/meal/MealsStructure";

const HygieneTaskCategories = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: pageLimit || 10,
    page: isPage + 1,
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getHygieneTaskCategories(filters) {
    dispatch(
      fetchHygineTaskCategoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getHygieneTaskCategories(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit || 10,
      page: isPage + 1,
      status: allFilters.isActive?.value || "",
    }));
    setIsPage(0);
  }, [pageLimit, isPage, allFilters.isActive]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Task Categories Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          {modValues.modName === "add" || modValues.modName === "edit" ? (
            <TaskCategoryForm
              isEdit={modValues.modName === "edit"}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={() => getHygieneTaskCategories(filters)}
              isCRUD={true}
            />
          ) : null}
        </Modal>

        <br />
        <Row>
          <Col>
            <MealsStructure
              text="Task Categories"
              isReload={() => getHygieneTaskCategories(filters)}
            />
          </Col>
        </Row>
        <br />

        <Row>
          <Col>
            <SearchNButtons
              pageName={"hygiene-task-categories"}
              btnText={"+ Add New Task Category"}
              onClickAdd={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }));
              }}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <HygieneCategoryListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getHygieneTaskCategories(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HygieneTaskCategories;
